import { mockCarouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            精选热门连载作品，编辑团队用心推荐，每一部都值得从头追到尾
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mockCarouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative w-full aspect-[5/3] overflow-hidden">
                <img
                  src={item.image}
                  alt={`虫虫漫画焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-heading text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-primary-500 font-medium mb-2">{item.subtitle}</p>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}